<template>
  <div v-if="isBrandDetermined" :class="currentBrand ? `brand-${currentBrand.slug}` : ''">
    <router-view class="app-route-placement"></router-view>

    <LoginModal />
    <Toaster />
    <HelpAndSupport :isShowModal="isShowHelpModal" />
  </div>
  <div v-else class="brand-loading" role="status" aria-live="polite">
    <div class="spinner-border" role="progressbar" aria-label="Loading application">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>
<script>
import HelpAndSupport from '@/components/HelpAndSupport.vue';
import LoginModal from './views/layouts/LoginModal.vue';
import Toaster from 'resonance-theme/src/vue/components/Toaster.vue';

export default {
  components: {
    HelpAndSupport,
    LoginModal,
    Toaster,
  },
  data() {
    return {
      isShowHelpModal: 0,
      isBrandDetermined: false,
    };
  },
  computed: {
    currentBrand() {
      return this.$store.getters['brand/currentBrand'];
    },
  },
  async created() {
    await this.determineBrand();
  },
  mounted() {
    // load Umami script if VUE_APP_UMAMI_URL is set
    if (process.env.VUE_APP_UMAMI_URL) {
      const script = document.createElement("script");
      script.defer = true;
      script.src = process.env.VUE_APP_UMAMI_URL;
      script.setAttribute("data-website-id", process.env.VUE_APP_UMAMI_ID);
      script.onload = () => {
        if (window.umami) {
          const userEmail = this.$auth?.auth ?? null; // logged-in user email
          if (userEmail) {
            window.umami.identify({ email: userEmail }); // identify user for the session
          }
        }
      };
      document.head.appendChild(script);
    }

    // handle the problem of navigating named anchors when routes don't change
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1);
    }

    // to show help & support modal
    this.$bus.on('show-support-form', () => {
      this.isShowHelpModal = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    });
  },
  methods: {
    async determineBrand() {
      try {
        // Fetch brands from API
        await this.$store.dispatch('brand/fetchBrands');

        // Determine current brand based on hostname
        const hostname = window.location.hostname;
        const currentBrand = await this.$store.dispatch('brand/determineBrand', hostname);

        this.isBrandDetermined = true;

        // Set the class of the <body> to brandClass
        if (currentBrand && currentBrand.slug) {
          document.body.classList.add(`brand-${currentBrand.slug}`);

          // Update favicon based on brand slug
          const favicon = document.querySelector('link[rel*="icon"]');
          if (favicon) {
            favicon.href = `/${currentBrand.slug}.ico`;
          }

          // Update page title with brand name
          if (currentBrand.name) {
            document.title = currentBrand.name;
          }
        }
      } catch (error) {
        console.error('Error determining brand:', error);
        this.isBrandDetermined = true; // Still allow app to load
      }
    },
    scrollTo: function (hashtag) {
      setTimeout(() => {
        location.href = hashtag;
      }, 1);
    },
  },
};
</script>
<style scoped>
.brand-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
</style>
